export class CrSiteShopTypeConst {
  public static OTHER = "3";
}
